import React from 'react';
import { Link } from 'react-router-dom';
import Button from '../components/common/Button';

const Home: React.FC = () => {
  // Temporary featured tools data
  const featuredTools = [
    {
      id: 1,
      name: 'ChatGPT',
      description: 'Advanced AI for versatile writing assistance',
      category: 'General Purpose',
      rating: 4.8,
    },
    {
      id: 2,
      name: 'Copy.ai',
      description: 'Specialized in marketing and copywriting',
      category: 'Marketing',
      rating: 4.6,
    },
    {
      id: 3,
      name: 'Jasper',
      description: 'AI content creation for businesses',
      category: 'Business',
      rating: 4.7,
    },
  ];

  return (
    <div className="space-y-16">
      {/* Hero Section */}
      <section className="text-center py-16 px-4 sm:px-6 lg:px-8 bg-gradient-to-r from-blue-500 to-blue-700 text-white rounded-2xl">
        <h1 className="text-4xl md:text-6xl font-bold mb-6">
          Find Your Perfect AI Writing Assistant
        </h1>
        <p className="text-xl md:text-2xl mb-8 max-w-3xl mx-auto">
          Compare top AI writing tools and find the one that best fits your needs
        </p>
        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <Link to="/quiz">
            <Button 
              variant="outline" 
              size="large" 
              className="border-2 border-white text-white hover:bg-white hover:text-blue-600 font-semibold"
            >
              Find Your Tool
            </Button>
          </Link>
          <Link to="/compare">
            <Button 
              variant="outline" 
              size="large" 
              className="border-2 border-white text-white hover:bg-white hover:text-blue-600 font-semibold"
            >
              Compare All Tools
            </Button>
          </Link>
        </div>
      </section>

      {/* Featured Tools Section */}
      <section>
        <h2 className="text-3xl font-bold mb-8 text-center">Featured AI Writing Tools</h2>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {featuredTools.map((tool) => (
            <div
              key={tool.id}
              className="bg-white p-6 rounded-lg shadow-md hover:shadow-lg transition-shadow"
            >
              <h3 className="text-xl font-semibold mb-2">{tool.name}</h3>
              <p className="text-gray-600 mb-4">{tool.description}</p>
              <div className="flex justify-between items-center">
                <span className="bg-blue-100 text-blue-800 px-3 py-1 rounded-full text-sm">
                  {tool.category}
                </span>
                <span className="text-yellow-500">★ {tool.rating}</span>
              </div>
              <Link to={`/tool/${tool.id}`}>
                <Button
                  variant="secondary"
                  className="w-full mt-4"
                >
                  Learn More
                </Button>
              </Link>
            </div>
          ))}
        </div>
      </section>

      {/* Why Choose Us Section */}
      <section className="bg-gray-50 p-8 rounded-xl">
        <h2 className="text-3xl font-bold mb-8 text-center">Why Choose TuringTalks</h2>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          <div className="text-center">
            <div className="bg-blue-100 w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-4">
              <svg className="w-8 h-8 text-blue-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
              </svg>
            </div>
            <h3 className="text-xl font-semibold mb-2">Unbiased Reviews</h3>
            <p className="text-gray-600">Honest, comprehensive reviews of all major AI writing tools</p>
          </div>
          <div className="text-center">
            <div className="bg-blue-100 w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-4">
              <svg className="w-8 h-8 text-blue-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 6l3 1m0 0l-3 9a5.002 5.002 0 006.001 0M6 7l3 9M6 7l6-2m6 2l3-1m-3 1l-3 9a5.002 5.002 0 006.001 0M18 7l3 9m-3-9l-6-2m0-2v2m0 16V5m0 16H9m3 0h3" />
              </svg>
            </div>
            <h3 className="text-xl font-semibold mb-2">Detailed Comparisons</h3>
            <p className="text-gray-600">Side-by-side comparisons of features, pricing, and performance</p>
          </div>
          <div className="text-center">
            <div className="bg-blue-100 w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-4">
              <svg className="w-8 h-8 text-blue-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 10V3L4 14h7v7l9-11h-7z" />
              </svg>
            </div>
            <h3 className="text-xl font-semibold mb-2">Expert Guidance</h3>
            <p className="text-gray-600">Personalized tool recommendations based on your needs</p>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Home; 